import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=0c449a8a&"
import script from "./Gallery.vue?vue&type=script&lang=coffee&"
export * from "./Gallery.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports